const ROOT = "fsa-media-player";
class FrontShockAssemblyMedia extends HTMLElement {
  connectedCallback() {
    if (this.dataset.fsaMediaInit === "true") return;
    this.dataset.fsaMediaInit = "true";
    this.loaded = false;
    this.observer = null;
    this.renderPoster();
    this.bind();
  }
  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
  bind() {
    if (!("IntersectionObserver" in window)) {
      this.activate();
      return;
    }
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          var _a;
          if (!entry.isIntersecting) return;
          this.activate();
          (_a = this.observer) == null ? void 0 : _a.disconnect();
          this.observer = null;
        });
      },
      {
        rootMargin: "160px 0px",
        threshold: 0.15
      }
    );
    this.observer.observe(this);
  }
  renderPoster() {
    const poster = this.dataset.poster || "";
    const title = this.dataset.title || "";
    if (poster) {
      this.innerHTML = `
        <img
          src="${poster}"
          alt="${this.escapeHtml(title)}"
          class="block h-full w-full object-cover"
          loading="lazy"
        >
      `;
      return;
    }
    this.innerHTML = '<div class="h-full w-full bg-[#d9d9d9]"></div>';
  }
  activate() {
    if (this.loaded) return;
    const type = this.dataset.type || "";
    const src = this.dataset.src || "";
    const title = this.dataset.title || "";
    const loopId = this.dataset.loopId || "";
    if (!type || !src) return;
    this.loaded = true;
    if (type === "youtube") {
      const joiner = src.includes("?") ? "&" : "?";
      this.innerHTML = `
        <iframe
          class="block h-full w-full border-0 object-cover"
          src="${src}${joiner}autoplay=1&mute=1&loop=1&playsinline=1${loopId ? `&playlist=${encodeURIComponent(loopId)}` : ""}"
          title="${this.escapeHtml(title)}"
          loading="lazy"
          frameborder="0"
          allow="autoplay; encrypted-media; picture-in-picture"
          allowfullscreen
        ></iframe>
      `;
      return;
    }
    if (type === "vimeo") {
      const joiner = src.includes("?") ? "&" : "?";
      this.innerHTML = `
        <iframe
          class="block h-full w-full border-0 object-cover"
          src="${src}${joiner}autoplay=1&muted=1&loop=1"
          title="${this.escapeHtml(title)}"
          loading="lazy"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen
        ></iframe>
      `;
      return;
    }
    if (type === "video") {
      this.innerHTML = `
        <video
          class="block h-full w-full object-cover"
          autoplay
          muted
          loop
          playsinline
          preload="metadata"
        >
          <source src="${src}" type="video/mp4">
        </video>
      `;
    }
  }
  escapeHtml(value) {
    return String(value).replaceAll("&", "&amp;").replaceAll('"', "&quot;").replaceAll("<", "&lt;").replaceAll(">", "&gt;");
  }
}
if (!window.customElements.get(ROOT)) {
  window.customElements.define(ROOT, FrontShockAssemblyMedia);
}
